module.exports = __webpack_public_path__ + "static/media/unaro-yellow-bg.9cb00d6a.svg";